import React, { useState } from "react";
import Swal from "sweetalert2";
import "../index.css";
import logo from "../images/LogoTransparente.png";

const Header = () => {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem("sidebarCollapsed") === "true";
  });

  const nameUser =
    localStorage.getItem("name") + " " + localStorage.getItem("lastName");

  const userType = localStorage.getItem("userType") || "";

  let timeout;

  const onLogout = () => {
    Swal.fire({
      title: "Cerrar sesión",
      text: "¿Estás seguro de que deseas cerrar sesión?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Salir",
      cancelButtonText: "Regresar",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        window.location.reload();
      }
    });
  };

  const handleScan = (value) => {
    clearTimeout(timeout);

    const message = document.getElementById("messageScann");
    if (message) message.style.display = "unset";

    timeout = setTimeout(() => {
      const code = value.split("=")[1];
      if (!code) return;

      const link = document.createElement("a");
      link.href = "/=" + code;
      link.target = "_blank";
      link.click();

      document.getElementById("scannCode").value = "";
      if (message) message.style.display = "none";
    }, 500);
  };

  return (
    <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      {/* HEADER */}
      <div className="sidebar-header">
        <button
          className={`sidebar-toggle ${collapsed ? "rotated" : ""}`}
          onClick={() => {
            const newValue = !collapsed;
            setCollapsed(newValue);
            localStorage.setItem("sidebarCollapsed", newValue);
          }}
          title={collapsed ? "Expandir menú" : "Colapsar menú"}
        >
          ☰
        </button>

        <img
          src={logo}
          alt="logo"
          className="sidebar-logo"
          onClick={() => (window.location.href = "/")}
          title="Inicio"
        />

        {!collapsed && <span className="sidebar-user">{nameUser}</span>}
      </div>

      {/* CONTENIDO CENTRAL */}
      <div className="sidebar-content">
        <nav className="sidebar-nav">
          <ul>
            {userType === "0" && (
              <>
                <MenuItem
                  href="/dashboard"
                  icon="👤"
                  label="Usuarios"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/dashboard/sucursales"
                  icon="🏢"
                  label="Sucursales"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/dashboard/clientes"
                  icon="🧑‍⚕️"
                  label="Pacientes"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/dashboard/citas"
                  icon="📅"
                  label="Citas"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/dashboard/pedidos"
                  icon="📦"
                  label="Pedidos"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/facturacion/CrearFactura"
                  icon="🧾"
                  label="Facturación"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/facturas/gestion"
                  icon="📑"
                  label="Gestión Facturas"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/cortes/corteIndividual"
                  icon="💰"
                  label="Corte de Caja"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/cortes/panelAdmin"
                  icon="📊"
                  label="Panel Cortes"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/whatsapp/enviarPromocion"
                  icon="💬"
                  label="Promociones WhatsApp"
                  collapsed={collapsed}
                />
              </>
            )}

            {(userType === "1" || userType === "2") && (
              <>
                <MenuItem
                  href="/dashboard"
                  icon="🧑‍⚕️"
                  label="Pacientes"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/dashboard/citas"
                  icon="📅"
                  label="Citas"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/dashboard/pedidos"
                  icon="📦"
                  label="Pedidos"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/facturacion/CrearFactura"
                  icon="🧾"
                  label="Facturación"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/facturas/gestion"
                  icon="📑"
                  label="Gestión Facturas"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/cortes/corteIndividual"
                  icon="💰"
                  label="Corte de Caja"
                  collapsed={collapsed}
                />
              </>
            )}

            {userType === "4" && (
              <>
                <MenuItem
                  href="/dashboard"
                  icon="🧑‍⚕️"
                  label="Pacientes"
                  collapsed={collapsed}
                />
                <MenuItem
                  href="/dashboard/citas"
                  icon="📅"
                  label="Citas"
                  collapsed={collapsed}
                />
              </>
            )}
          </ul>
        </nav>

        {!collapsed && (
          <div className="sidebar-scan">
            <span id="messageScann" className="scan-message">
              Escaneando...
            </span>
            <input
              id="scannCode"
              type="text"
              placeholder="Click y escanee QR"
              className="form-control inputTextTransparent"
              onInput={(e) => handleScan(e.target.value)}
              style={{ cursor: "pointer" }}
            />
          </div>
        )}
      </div>

      {/* LOGOUT */}
      <button
        onClick={onLogout}
        className={`btn btn-secondary sidebar-logout ${
          collapsed ? "icon-only" : ""
        }`}
        title="Cerrar sesión"
      >
        <span className="logout-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </span>

        {!collapsed && <span className="logout-text">Cerrar sesión</span>}
      </button>
    </aside>
  );
};

/* COMPONENTE MENU ITEM */
const MenuItem = ({ href, icon, label, collapsed }) => (
  <li>
    <a href={href} className="sidebar-link" title={label} style={{ paddingLeft:"0"}}>
      <span className="sidebar-icon" style={{ fontSize: 18}}>{icon}</span>
      {!collapsed && <span className="sidebar-text">{label}</span>}
    </a>
  </li>
);

export default Header;
